module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/tools_desktop-6be8081690156d3d9207b2ce1116e92f.png";